const PatientEthnicity = {
    HISPANIC_OR_LATINO: "Hispanic or Latino",
    NOT_HISPANIC_OR_LATINO: "Not Hispanic or Latino",
    UNKNOWN: "Unknown"
};

export default PatientEthnicity;